(function () {
  if (window.innerWidth < 750) return;

  var backdrop = document.getElementById('et-account-backdrop');
  var accountBtn = document.querySelector('.account-button');
  if (!backdrop || !accountBtn) return;

  var isOpen = false;
  var centered = null;
  var pollTimer = null;

  /* ── Recursively search shadow roots ── */
  function deepFind(selector, root) {
    root = root || document.body;
    var found = root.querySelector(selector);
    if (found) return found;
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var sr = all[i].shadowRoot;
      if (sr) {
        found = deepFind(selector, sr);
        if (found) return found;
      }
    }
    return null;
  }

  /* ── Find the account dialog anywhere in the page ── */
  function findDialog() {
    /* 1. Any open <dialog> that isn't cart/search/quick-add */
    var dialogs = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < dialogs.length; i++) {
      var d = dialogs[i];
      var id = (d.id || '').toLowerCase();
      var cls = (d.className || '').toLowerCase();
      if (id.indexOf('cart') < 0 && id.indexOf('search') < 0 && id.indexOf('quick') < 0 &&
          cls.indexOf('cart') < 0 && cls.indexOf('search') < 0) {
        return d;
      }
    }

    /* 2. Popover that became visible */
    var popovers = document.querySelectorAll('[popover]');
    for (var j = 0; j < popovers.length; j++) {
      var p = popovers[j];
      if (p.id === 'et-account-backdrop') continue;
      try {
        var cs = window.getComputedStyle(p);
        if (cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0') return p;
      } catch (e) {}
    }

    /* 3. Deep-search shadow DOM for dialog or role=dialog */
    var sa = document.querySelector('shopify-account');
    if (sa) {
      var shadow = sa.shadowRoot;
      if (shadow) {
        var sd = shadow.querySelector('dialog, [role="dialog"], [class*="panel"], [class*="modal"]');
        if (sd) return sd;
      }
      var ld = sa.querySelector('dialog, [role="dialog"]');
      if (ld) return ld;
    }

    /* 4. Full deep search as last resort */
    return deepFind('dialog[open]') || deepFind('[role="dialog"]');
  }

  /* ── Apply centering directly on the element ── */
  function applyCenter(el) {
    if (centered === el) return;
    centered = el;
    var s = el.style;
    s.setProperty('position',      'fixed',               'important');
    s.setProperty('inset',         'auto',                'important');
    s.setProperty('top',           '50%',                 'important');
    s.setProperty('left',          '50%',                 'important');
    s.setProperty('right',         'auto',                'important');
    s.setProperty('bottom',        'auto',                'important');
    s.setProperty('transform',     'translate(-50%,-50%)','important');
    s.setProperty('margin',        '0',                   'important');
    s.setProperty('z-index',       '99999',               'important');
    s.setProperty('background',    '#ffffff',              'important');
    s.setProperty('background-color','#ffffff',           'important');
    s.setProperty('color',         '#1a1714',             'important');
    s.setProperty('width',         'min(560px,92vw)',      'important');
    s.setProperty('max-height',    '90dvh',               'important');
    s.setProperty('overflow-y',    'auto',                'important');
    s.setProperty('border-radius', '16px',                'important');
    s.setProperty('padding',       '1.6rem 2rem',         'important');
    s.setProperty('box-shadow',    '0 8px 16px rgba(0,0,0,0.08),0 24px 64px rgba(0,0,0,0.22),0 0 0 1px rgba(124,112,82,0.15)', 'important');

    /* ── Watch for X button / native close ── */
    if (!el._etCloseWired) {
      el._etCloseWired = true;

      /* native <dialog> fires 'close' event */
      el.addEventListener('close', function () {
        backdrop.classList.remove('et-backdrop--active');
        isOpen = false;
        centered = null;
      });

      /* MutationObserver: if dialog loses [open] attr or is removed */
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          /* removed from DOM */
          if (m.type === 'childList') {
            m.removedNodes.forEach(function (n) {
              if (n === el || n.contains && n.contains(el)) {
                backdrop.classList.remove('et-backdrop--active');
                isOpen = false;
                centered = null;
              }
            });
          }
          /* [open] attribute removed */
          if (m.type === 'attributes' && m.attributeName === 'open' && !el.hasAttribute('open')) {
            backdrop.classList.remove('et-backdrop--active');
            isOpen = false;
            centered = null;
          }
        }
      }).observe(el.parentNode || document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });

      /* Delegate click on any close/X button inside the dialog */
      el.addEventListener('click', function (e) {
        var t = e.target;
        var isClose = false;
        while (t && t !== el) {
          var label = (t.getAttribute('aria-label') || '').toLowerCase();
          var cls   = (t.className || '').toLowerCase();
          var type  = (t.type || '').toLowerCase();
          if (label.indexOf('close') >= 0 || cls.indexOf('close') >= 0 || cls.indexOf('dismiss') >= 0 ||
              (t.tagName === 'BUTTON' && (type === '' || type === 'button') && cls.indexOf('cancel') >= 0)) {
            isClose = true;
            break;
          }
          t = t.parentElement;
        }
        if (isClose) {
          setTimeout(function () {
            backdrop.classList.remove('et-backdrop--active');
            isOpen = false;
            centered = null;
          }, 80);
        }
      });
    }
  }

  /* ── Start polling after click ── */
  function tryOpen() {
    /* Show backdrop immediately — don't wait for dialog to be found */
    backdrop.classList.add('et-backdrop--active');
    isOpen = true;

    var tries = 0;
    clearInterval(pollTimer);
    pollTimer = setInterval(function () {
      var d = findDialog();
      if (d) {
        clearInterval(pollTimer);
        applyCenter(d);
      } else if (++tries > 60) { /* 3 seconds max */
        clearInterval(pollTimer);
      }
    }, 50);
  }

  /* ── Close ── */
  function doClose() {
    clearInterval(pollTimer);
    backdrop.classList.remove('et-backdrop--active');
    isOpen = false;
    centered = null;
    var sa = document.querySelector('shopify-account');
    if (sa) sa.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true, cancelable: true }));
    var d = findDialog();
    if (d) {
      if (typeof d.close === 'function') d.close();
      if (d.hasAttribute && d.hasAttribute('popover') && d.hidePopover) d.hidePopover();
    }
  }

  /* ── Account button click ── */
  accountBtn.addEventListener('click', function () {
    setTimeout(function () {
      if (isOpen) { doClose(); } else { tryOpen(); }
    }, 30);
  });

  /* ── Backdrop click ── */
  backdrop.addEventListener('click', doClose);

  /* ── Escape key ── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) {
      backdrop.classList.remove('et-backdrop--active');
      isOpen = false;
      centered = null;
      clearInterval(pollTimer);
    }
  });

  /* ── MutationObserver: re-apply if dialog re-renders ── */
  new MutationObserver(function () {
    if (!isOpen) return;
    var d = findDialog();
    if (d && d !== centered) applyCenter(d);
  }).observe(document.body, { childList: true, subtree: true });

  /* ── Resize: disable on mobile ── */
  window.addEventListener('resize', function () {
    if (window.innerWidth < 750 && isOpen) doClose();
  });
})();
